import styled from "styled-components"

const VSpace = styled.div`
  height: ${(props) => props.length}px;
  flex-shrink: 0;
`

export default VSpace
